import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

import { useSDK } from '../../app';
import { Theme } from '../../theme/interface/detailed';

const Component = ({ className }: { className: string }): ReactElement => {
	const { eventsStore } = useSDK();
	return <div className={className}>{eventsStore.unreadMessages > 99 ? '99+' : eventsStore.unreadMessages}</div>;
};

export const UnreadCount = styled(observer(Component))(
	({ theme }: { theme?: Theme }) => theme?.allSettings.containers.unreadCount
);
